import { defineMessages } from 'react-intl';

export default defineMessages({
  geo: {
    id: 'ReactFilters.messages.filterTitles.geo',
    defaultMessage: 'Geolocation',
  },
  addMethod: {
    id: 'ReactFilters.messages.filterTitles.addMethod',
    defaultMessage: 'Provenance',
  },
  memberUid: {
    id: 'ReactFilters.messages.filterTitles.memberUid',
    defaultMessage: 'Member',
  },
  locationUid: {
    id: 'ReactFilters.messages.filterTitles.locationUid',
    defaultMessage: 'Location',
  },
  sourceAgendaUid: {
    id: 'ReactFilters.messages.filterTitles.sourceAgendaUid',
    defaultMessage: 'Source agenda',
  },
  originAgendaUid: {
    id: 'ReactFilters.messages.filterTitles.originAgendaUid',
    defaultMessage: 'Origin agenda',
  },
  featured: {
    id: 'ReactFilters.messages.filterTitles.featured',
    defaultMessage: 'Featured',
  },
  relative: {
    id: 'ReactFilters.messages.filterTitles.relative',
    defaultMessage: 'Passed / current / upcoming',
  },
  region: {
    id: 'ReactFilters.messages.filterTitles.region',
    defaultMessage: 'Region',
  },
  department: {
    id: 'ReactFilters.messages.filterTitles.department',
    defaultMessage: 'Department',
  },
  city: {
    id: 'ReactFilters.messages.filterTitles.city',
    defaultMessage: 'City',
  },
  adminLevel3: {
    id: 'ReactFilters.messages.filterTitles.adminLevel3',
    defaultMessage: 'Administrative level 3',
  },
  timings: {
    id: 'ReactFilters.messages.filterTitles.timings',
    defaultMessage: 'Date',
  },
  createdAt: {
    id: 'ReactFilters.messages.filterTitles.createdAt',
    defaultMessage: 'Creation date',
  },
  updatedAt: {
    id: 'ReactFilters.messages.filterTitles.updatedAt',
    defaultMessage: 'Date of update',
  },
  keyword: {
    id: 'ReactFilters.messages.filterTitles.keyword',
    defaultMessage: 'Keywords'
  },
  state: {
    id: 'ReactFilters.messages.filterTitles.state',
    defaultMessage: 'State',
  },
  attendanceMode: {
    id: 'ReactFilters.messages.filterTitles.attendanceMode',
    defaultMessage: 'Attendance mode',
  },
  status: {
    id: 'ReactFilters.messages.filterTitles.status',
    defaultMessage: 'Status',
  },
  district: {
    id: 'ReactFilters.messages.filterTitles.district',
    defaultMessage: 'District',
  },
});
